import { apiRequest } from '@/utils/api-request';
import { useOrgStore } from '@/stores/org-store';

export const deleteTest = async (
  testId: string,
): Promise<{ message: string; id: string }> => {
  const orgId = useOrgStore.getState().currentOrg?.orgid;

  const response = await apiRequest<{ message: string; id: string }>({
    url: `/evaluations/test/${orgId}/${testId}`,
    target: 'platform',
    method: 'DELETE',
  });
  return response?.data as { message: string; id: string };
};
